<template>
    <div class="flex items-center gap-1">
        <button
            v-for="star in max"
            :key="star"
            type="button"
            @click="setRating(star)"
            @mouseenter="hoveredRating = star"
            @mouseleave="hoveredRating = 0"
            class="transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded"
            :class="[
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:scale-110'
            ]"
            :disabled="disabled"
        >
            <UIcon
                :name="getStarIcon(star)"
                :class="[
                    'transition-colors duration-200',
                    getStarColor(star)
                ]"
                :size="size"
            />
        </button>
        <span v-if="showValue && modelValue > 0" class="ml-2 text-sm text-gray-600 dark:text-gray-400">
            {{ modelValue }}/{{ max }}
        </span>
    </div>
</template>

<script setup lang="ts">
const {
    modelValue = 0,
    max = 5,
    size = '1.5rem',
    disabled = false,
    showValue = false
} = defineProps<{
    modelValue: number | undefined;
    max?: number;
    size?: string;
    disabled?: boolean;
    showValue?: boolean;
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void;
}>();

const hoveredRating = ref(0);

const setRating = (rating: number) => {
    if (disabled) return;
    emit('update:modelValue', rating);
};

const getStarIcon = (star: number): string => {
    const currentRating = hoveredRating.value || modelValue;
    
    if (star <= currentRating) {
        return 'i-heroicons-star-solid';
    }
    return 'i-heroicons-star';
};

const getStarColor = (star: number): string => {
    const currentRating = hoveredRating.value || modelValue;
    
    if (star <= currentRating) {
        return 'text-yellow-400';
    }
    return 'text-gray-300 dark:text-gray-600';
};
</script>
